import React, { PropsWithChildren } from 'react';

import { getDutchFormattedDateTime } from '../../utils/string-utils';

import packageInfo from '../../../package.json';

interface Props extends PropsWithChildren {
  noIndex?: boolean;
  description?: string;
  title: string;
  canonical?: string;
  image?: string;
}

const SEO = ({
  noIndex,
  description = '',
  title,
  canonical,
  image,
  children,
}: Props) => {
  const stamp = {
    version: packageInfo.version,
    dateTime: getDutchFormattedDateTime(),
  };

  const renderVersion = `${stamp.version} | ${stamp.dateTime}`;

  return (
    <>
      <title>{title}</title>
      <meta name="version" content={renderVersion} />
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      <meta
        name="google-site-verification"
        content="nt59jB9-iE7TUPyCVuPf6X_3mTtKWAHgHtWMi2Kyj78"
      />
      {(process.env.GATSBY_STAGE === 'development' ||
        process.env.GATSBY_STAGE === 'acceptance' ||
        noIndex) && <meta name="robots" content="noindex, nofollow" />}
      {canonical && <link rel="canonical" href={canonical} />}
      {children}
    </>
  );
};

export default SEO;
